import { makeStyles } from '@material-ui/core';
import MuiLink, { LinkProps } from '@material-ui/core/Link';
import React from 'react';
import { GatsbyLink } from './gatsby';

type CustomLinkProps = {
  to?: string;
  styled?: any;
};

const useStyles = makeStyles(theme => ({
  root: (props: CustomLinkProps) =>
    props.styled
      ? {
          position: 'relative',
          display: 'inline-block',

          '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '2px',
            bottom: '-2px',
            left: '0',
            visibility: 'hidden',
            transform: 'scaleX(0)',
            transformOrigin: 'left',
            transition: '0.25s',
            background: theme.palette.primary.main,
          },
          '&:hover, &:focus, &:active': {
            textDecoration: 'none',
            '&:before': {
              visibility: 'visible',
              transform: 'scaleX(1)',
            },
          },
        }
      : {},
}));

const Link = React.forwardRef<HTMLAnchorElement, LinkProps & CustomLinkProps>((props, ref) => {
  const classes = useStyles(props);
  let { className, to, ...otherProps } = props;
  className = `${classes.root} ${className}`;
  return to ? (
    <MuiLink className={className} ref={ref} component={GatsbyLink} to={to} {...otherProps} />
  ) : (
    <MuiLink className={className} ref={ref} {...props} />
  );
});

export default Link;
